import type { OnInit } from '@angular/core';
import { Component, ElementRef, forwardRef, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseSelectFormFieldComponent } from '@shared/form-fields/select/base-select-form-field.component';
import {
    MinimumContractValueType
} from '@shared/modules/contracts/common/minimum-contract-value/minimum-contract-value';
import type {
    MinimumContractValuePeriod
} from '@shared/modules/contracts/common/minimum-contract-value/minimum-contract-value-period';

@Component({
    selector: 'app-minimum-contract-value-period-select',
    styleUrls: ['./minimum-contract-value-period-select.component.scss'],
    templateUrl: '../../../../../form-fields/select/select-form-field.component.html',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MinimumContractValuePeriodSelectComponent), multi: true }],
})
export class MinimumContractValuePeriodSelectComponent extends BaseSelectFormFieldComponent<MinimumContractValuePeriod> implements OnInit {

    constructor(element: ElementRef, renderer: Renderer2) {
        super(element, renderer);

        this._options = [
            { value: MinimumContractValueType.weekly, label: 'Weekly' },
            { value: MinimumContractValueType.daily, label: 'Daily' },
        ];
    }

}
